
import Ajax from '../js/common/ajax';

export default {
	voucherCount() {
		return Ajax.get("/home/voucher/count")
	},
	chart: {
		revenueProfit() {
			return Ajax.get("/home/chart/revenueProfit")
		},
		cost() {
			return Ajax.get("/home/chart/cost")
		},
		cash() {
			return Ajax.get("/home/chart/cash")
		},
		cope() {
			return Ajax.get("/home/chart/cope")
		},
		businessTrends() {
			return Ajax.get("/home/chart/businessTrends")
		}
	}
}
